<div id="transport-intervention-report-map" class="transport-intervention-report-map"
     leaflet
     [leafletOptions]="mapOptions"
     (leafletMapReady)="onMapReady($event)">
</div>
<app-map-layers-control [mapReady]="mapReady$" [layers]="layers"></app-map-layers-control>
<dx-load-panel
  class="route-loading"
  shadingColor="rgba(0,0,0,0.2)"
  [(visible)]="isRouteLoading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false">

  <div *dxTemplate="let data of 'content'">{{routeLoader.loadedStr()}}</div>
</dx-load-panel>
